module.exports = __webpack_public_path__ + "img/mdi_filter.8415fc4c.png";